// extracted by mini-css-extract-plugin
module.exports = {"read_more":"Map_read_more__1dMgJ"};